import { styled } from '@clickcease/cc-client-components-lib'

export const IconButton = styled('button', {
  all: 'unset',
  fontFamily: 'inherit',
  borderRadius: '100%',
  padding: '5px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '$textColor',
  cursor: 'pointer',
})
